module.exports = __webpack_public_path__ + "media/images/emblems/Balm_bei_Guensberg-blason-1670f97eb5d7e2e63a2941d22713f68c.png";